(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment time past modal 
    module.controller('AgendaAppointmentTimePastModalController',
        ['$uibModalInstance',
        'timeBeforeToday',
        AgendaAppointmentTimePastModalControllerFn]);

    function AgendaAppointmentTimePastModalControllerFn($uibModalInstance, timeBeforeToday) {
        var vm = this;

        vm.timeBeforeToday = timeBeforeToday;

        // don't book appointment -> block = true
        vm.no = function () {
            $uibModalInstance.close(true);
        };

        // book appointment ->  block = false
        vm.yes = function () {
            $uibModalInstance.close(false);
        };

    }

})();